export const isDev = () => {
    return !process.env.NODE_ENV || process.env.NODE_ENV === "development";
};

export const getSentryDsn = (): string => {
    const SentryDsn = process.env.REACT_APP_SENTRY_DSN;
    return SentryDsn && !isDev() ? SentryDsn : "";
};
